
export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/bfc67ed0097d85d03bb3ed71e26f7b0d.jpg"
                alt="DELKO Team Workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block px-6 py-2 bg-teal-50 rounded-full mb-6">
              <span className="text-sm font-semibold text-teal-700 uppercase tracking-wide">Who We Are</span>
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Expert iOS Development Team
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              DELKO d.o.o. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              We combine cutting-edge technology with intuitive design to deliver applications that not only meet but exceed user expectations. Our commitment to quality and innovation drives everything we do.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
